var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 119,
    viewBox: "0 0 122 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5625,
    y: 1,
    width: 115.063,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5625,
    y: 3,
    width: 115.063,
    height: 115,
    rx: 19,
    stroke: "#11141D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5781 89H51.2844L58.3791 76.5307H78.5991V59.905H68.3118L78.5991 39.1229V27H65.8286L58.3791 39.1229H39.5781V55.0559H51.2844L39.5781 74.7989V89Z",
    stroke: "#11141D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5859 92H53.2922L60.387 79.5307H80.6069V62.905H70.3196L80.6069 42.1229V30H67.8364L60.387 42.1229H41.5859V58.0559H53.2922L41.5859 77.7989V92Z",
    stroke: "#11141D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.e5e3a60b5a7467b2645a6bae4aaf1bd1.svg";
export { ForwardRef as ReactComponent };